// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const WipProductTracking = t.struct({
    registrationReviews: t.Number,
    transferApprovals: t.Number
}, {
    name: 'WipProductTracking',
    strict: true
});

export const getDefaultState = () => new WipProductTracking({
    registrationReviews: 0,
    transferApprovals: 0
});

export default WipProductTracking;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/wip-product-tracking.js